import axForm from "./axForm";

// 获取用户状态
export function RedirectPay(data = {}) {
  return axForm({
    url: "/default/RedirectPay",
    method: "post",
    data
  });
}